module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mensagem.remetente.id !== _vm.currentUser.id) ? _c('chat-conversa-mensagem-terceiro', {
    attrs: {
      "mensagem": _vm.mensagem
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mensagem.remetente.id === _vm.currentUser.id) ? _c('chat-conversa-mensagem-propria', {
    attrs: {
      "mensagem": _vm.mensagem
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d6c844c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/chat/components/ChatConversaMensagem.vue
// module id = 1606
// module chunks = 17